import { Label } from "../ui/label";

export default function FormField({ label, children, full }) {
  return (
    <div className={`space-y-1 ${full ? "md:col-span-2" : ""}`}>
      <Label className="text-xs uppercase tracking-wider text-slate-500">{label}</Label>
      {children}
    </div>
  );
}
